import Vue from 'vue'
import Vuex from 'vuex'
import { formatLatLon } from '@/utils/format'

Vue.use(Vuex)

function enrichCity(city) {
    if (!city || city.lat == null || city.lon == null) return city
    const lat = parseFloat(city.lat)
    const lon = parseFloat(city.lon)
    const flag = city.country_iso
        ? [...city.country_iso.toUpperCase()].map(c => String.fromCodePoint(0x1F1E6 + c.charCodeAt(0) - 65)).join('')
        : (city.country_flag || '')
    return {
        ...city,
        formatted_latitude: formatLatLon(lat, false),
        formatted_longitude: formatLatLon(lon, true),
        country_flag: flag,
    }
}

export default new Vuex.Store({
    state: {
        city: {},
        date: null,
        time: null,
        cityDatetime: null,
        isLocatorEnabled: false,
        apiLocked: false,
    },
    mutations: {
        setCity(state, city) {
            state.city = enrichCity(city)
        },
        setDate(state, date) {
            state.date = date
        },
        setTime(state, time) {
            state.time = time
        },
        setCityDatetime(state, cityDatetime) {
            state.cityDatetime = cityDatetime
        },
        setLocatorEnabled(state, value) {
            state.isLocatorEnabled = value
        },
        toggleLocator(state) {
            state.isLocatorEnabled = !state.isLocatorEnabled
        },
        lockApi(state) {
            state.apiLocked = true
        },
    },
})
